import React, { useEffect, useState } from 'react'
import GradientButton from 'components/Button/GradientButton'
import OutlineButton from 'components/Button/OutlineButton'
import styles from './index.module.scss'

const ArtworkTab = props => {
  const { ownershipList, handleOwnership } = props
  const [selectedOwnership, setSelectedOwnership] = useState('all')

  useEffect(() => {
    let names = []
    ownershipList.map(item => item.checked && names.push(item.name))

    if (names.length === 0) setSelectedOwnership('all')
    else {
      setSelectedOwnership(names[0].toLowerCase())
    }
  }, [ownershipList])

  return (
    <div className={styles.container}>
      <div className="min-w-[66px]">
        {selectedOwnership === 'all' ? (
          <GradientButton
            label="All"
            backgroundColor={'var(--bg-FFF-202427)'}
            width={66}
            height={43}
            onClick={() => {}}
          />
        ) : (
          <OutlineButton
            label="All"
            backgroundColor={'rgba(var(--main-bg-color-rgb), 0.1)'}
            fontFamily="Jost-Regular"
            color="var(--bg-A5A5A5-606060)"
            borderColor="transparent"
            width={66}
            height={43}
            onClick={() => {
              handleOwnership(-1)
            }}
          />
        )}
      </div>

      <div className="min-w-[85px] xl:min-w-[106px]">
        {selectedOwnership === 'created' ? (
          <GradientButton
            label="Created"
            backgroundColor={'var(--bg-FFF-202427)'}
            fullWidth
            height={43}
            onClick={() => {}}
          />
        ) : (
          <OutlineButton
            label="Created"
            backgroundColor={'rgba(var(--main-bg-color-rgb), 0.1)'}
            fontFamily="Jost-Regular"
            color="var(--bg-A5A5A5-606060)"
            borderColor="transparent"
            fullWidth
            height={43}
            onClick={() => {
              handleOwnership(0)
            }}
          />
        )}
      </div>

      <div className="min-w-[100px] xl:min-w-[118px]">
        {selectedOwnership === 'collected' ? (
          <GradientButton
            label="Collected"
            backgroundColor={'var(--bg-FFF-202427)'}
            fullWidth
            height={43}
            onClick={() => {}}
          />
        ) : (
          <OutlineButton
            label="Collected"
            backgroundColor={'rgba(var(--main-bg-color-rgb), 0.1)'}
            fontFamily="Jost-Regular"
            color="var(--bg-A5A5A5-606060)"
            borderColor="transparent"
            fullWidth
            height={43}
            onClick={() => {
              handleOwnership(1)
            }}
          />
        )}
      </div>

      <div className="min-w-[110px] xl:min-w-[130px]">
        {selectedOwnership === 'collections' ? (
          <GradientButton
            label="Collections"
            backgroundColor={'var(--bg-FFF-202427)'}
            fullWidth
            height={43}
            onClick={() => {}}
          />
        ) : (
          <OutlineButton
            label="Collections"
            backgroundColor={'rgba(var(--main-bg-color-rgb), 0.1)'}
            fontFamily="Jost-Regular"
            color="var(--bg-A5A5A5-606060)"
            borderColor="transparent"
            fullWidth
            height={43}
            onClick={() => {
              handleOwnership(2)
            }}
          />
        )}
      </div>

      <div className="min-w-[140px] xl:min-w-[156px]">
        {selectedOwnership === 'physical prints' ? (
          <GradientButton
            label="Physical Prints"
            backgroundColor={'var(--bg-FFF-202427)'}
            fullWidth
            height={43}
            onClick={() => {}}
          />
        ) : (
          <OutlineButton
            label="Physical Prints"
            backgroundColor={'rgba(var(--main-bg-color-rgb), 0.1)'}
            fontFamily="Jost-Regular"
            color="var(--bg-A5A5A5-606060)"
            borderColor="transparent"
            fullWidth
            height={43}
            onClick={() => {
              handleOwnership(3)
            }}
          />
        )}
      </div>
    </div>
  )
}

export default ArtworkTab
